<!--  -->
<template>
  <div>

    <el-form
      :label-position="labelPosition"
      label-width="120px"
      :model="formLabelAlign"
    >
      <el-form-item
        v-if="formLabelAlign.type==1"
        label="是否启用"
      >
        <!-- <el-tag
          v-if="formLabelAlign.enable == 2&&formLabelAlign.type==1"
          type="danger"
        >未开启</el-tag>
        <el-tag
          v-if="formLabelAlign.enable == 1&&formLabelAlign.type==1"
          type="danger"
        >开启中</el-tag> -->
        <div style="position: relative; display: inline-block;margin:0 10px 10px 10px">
          <div>
            <div style="position: relative; display: inline-block;">
              <el-switch
                v-model="formLabelAlign.enable"
                :width="60"
                :handle-size="80"
                active-color="#13ce66"
                inactive-color="rgb(191,191,191)"
                :active-value="1"
                :inactive-value="2"
              />
              <!-- @change="statusChange" -->
              <div
                v-if="formLabelAlign.enable == 1&&formLabelAlign.type==1"
                style="color: #fff; position: absolute;pointer-events: none; top: 2px; left: 7px;"
              >启用</div>
              <div
                v-if="formLabelAlign.enable == 2&&formLabelAlign.type==1"
                style="color: #fff; position: absolute;pointer-events: none; top: 2px; right: 7px;"
              >关闭</div>
            </div>
            <span class="color"> 鼠标出现小手可点击切换</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="小程序类型">
        <el-select
          v-model="formLabelAlign.type"
          placeholder="请选择小程序类型"
          @change="chanegertype"
        >
          <el-option
            v-for="item in optionsr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <!-- <el-form-item v-if="formLabelAlign.type===3" label="企业">
        <el-select v-model="formLabelAlign.corp_id" class="corp_id" multiple filterable placeholder="请选择企业">
          <el-option
            v-for="item in tableData"
            :key="item.id"
            :label="item.corp_name"
            :value="item.corp_id"
          />
        </el-select>
      </el-form-item> -->
      <el-form-item
        v-if="formLabelAlign.type == 3 || formLabelAlign.type===1"
        label="预览公众号"
      >
        <!-- <el-select v-model="app_idr" filterable placeholder="请选择预览公众号">
          <el-option
            v-for="item in tableDataappid"
            :key="item.app_id"
            :label="item.account_name"
            :value="item.app_id"
          />
        </el-select> -->
        <el-autocomplete
          v-model="app_idrname"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          @select="handleSelect"
          @input="cjader"
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="formLabelAlign.remark"
          style="width: 300px;"
        />
      </el-form-item>
      <!-- <el-form-item v-if="ghId" label="gh_id">
        <el-input v-model="formLabelAlign.gh_id" />
      </el-form-item> -->
      <!-- <el-form-item v-if="formLabelAlign.type===3 || formLabelAlign.type===1" label="小程序名称">
        <el-select id="selectInput" ref="searchSelect" v-model="value" filterable placeholder="请选择" :filter-method="dataFilter" @visible-change="visibleChange" @focus="selectFocus" @blur="selectBlur" @change="selectChange">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-tag type="danger" style="font-size: 15px;margin-left: 10px;">小程序名称务必与APPID相对应</el-tag>
      </el-form-item> -->
      <el-form-item
        v-if="formLabelAlign.type===3 || formLabelAlign.type===1"
        label="标题"
      >
        <el-input
          v-model="formLabelAlign.title"
          style="width: 500px;"
        />
      </el-form-item>
      <el-form-item
        v-if="formLabelAlign.type===3 || formLabelAlign.type===1"
        label="APPID"
      >
        <el-input v-model="formLabelAlign.app_id" />
      </el-form-item>
      <el-form-item
        v-if="formLabelAlign.type===3 || formLabelAlign.type===1"
        label="页面路径"
      >
        <el-input v-model="formLabelAlign.pagepath" />
      </el-form-item>
      <el-form-item label="路径以html结尾">
        <el-radio-group v-model="formLabelAlign.check" @input="radioCheck(formLabelAlign)">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="formLabelAlign.type===3"
        label="强关路径（自研短剧用）"
      >
        <el-input
          v-model="formLabelAlign.recent_reading_page"
          disabled
        />
      </el-form-item>
      <el-form-item
        v-if="formLabelAlign.type===3 || formLabelAlign.type===1"
        label="封面"
      >
        <div class="formimg">
          <img
            v-if="formLabelAlign.source_material_id!=null"
            :src="source_material_img"
            alt=""
            style="width: 100px;height: 100px;margin-right: 10px;"
          >
          <el-button
            type="success"
            size="mini"
            @click="chooseimg"
          >选择封面</el-button>
          <span style="color:#ccc;margin-left: 10px;" class="options">图片建议大小为520*416</span>
        </div>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          @click="sumbit"
        >保存</el-button>
        <el-button
          v-if="formLabelAlign.type == 3 || formLabelAlign.type===1"
          type="primary"
          @click="previewrww"
        >预览</el-button>
      </el-form-item>
    </el-form>

    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletwo"
      width="50%"
      append-to-body
    >
      <chooseimg
        ref="mychild"
        @clickicon="clickicon"
      />
    </el-dialog>
  </div>
</template>

<script>
import { updateByMpId, spCorplist, repeatMiniprogramList, createMiniprogram } from '@/api/officialaccount.js'
// import chooseimg from './chooseimg.vue'
import chooseimg from '../../menumanagement/components/TencentCloudChooseimg.vue'
import { officialAccountlist } from '@/api/sourceMaterial.js'
export default {
  components: { chooseimg },
  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        type: '',
        remark: '',
        id: '',
        // corp_id: '',
        title: '',
        // des_1: '',
        app_id: '',
        pagepath: '',
        source_material_id: null,
        recent_reading_page: '',
        enable: 2, // 1.启用 2未启用
        check: true
        // gh_id: ''
      },
      app_idr: '',
      app_idrname: '',
      tableDataappid: [],
      source_material_img: '',
      optionsr: [
        {
          value: 1,
          label: '企微消息小程序'
        },
        {
          value: 2,
          label: '微信客服小程序'
        },
        {
          value: 3,
          label: '微信官方小程序'
        }
      ],
      tableData: [],
      query: {
        page: 1,
        pageSize: 500,
        keywords: null,
        suite_id: null
      },
      dialogVisibletwo: false,
      options: [],
      optionsFilter: [],
      value: '',
      ghId: false,
      appquery: {
        page: 1,
        pageSize: 1000,
        onlyMe: 1
      },
      alltype: null,
      link: []
    }
  },
  created() {
    console.log(this.formLabelAlign.enable)
  },
  mounted() {
    this.list()
  },
  methods: {
    statusChange(e) {
      console.log('e:', e)
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.enable == 2) {
        // 开关打开的逻辑
        this.$confirm('确认关闭？')
          .then(_ => {
            console.log('关闭')
          })
          .catch(_ => {
            this.formLabelAlign.enable = 1
            console.log(this.formLabelAlign.enable)
          })
      } else {
        // 开关关闭的逻辑
        this.$confirm('确认启用？')
          .then(_ => {
            console.log('启用')
          })
          .catch(_ => {
            this.formLabelAlign.enable = 2
            console.log(this.formLabelAlign.enable)
          })
      }
      console.log(this.formLabelAlign.enable)
    },

    async listre() {
      // const data = await officialAccountlist(this.appquery)
      // this.tableDataappid = data.data.list
      // // this.total = data.data.total
      // console.log('data', data)
    },
    async list() {
      const data = await spCorplist(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data-----------', data)
    },
    // 搜索手机编号
    async querySearchAsync(value, cb) {
      const data = await officialAccountlist({ account_name: value, page: 1, pageSize: 100, onlyMe: 1 })
      cb(
        data.data.list.map(item => {
          return { ...item, value: item.account_name }
        })
      )
    },
    handleSelect(item) {
      this.app_idr = item.app_id
      // this.parameter.content.app_id = item.app_id
      // console.log('++++++',item);
    },
    cjader(val) {
      // eslint-disable-next-line eqeqeq
      if (val == '') {
        console.log('jin')
        this.app_idr = ''
      }
      console.log(val)
    },
    async sumbit() {
      if (this.formLabelAlign.type === '') {
        this.$message({
          type: 'error',
          message: `请选择类型`
        })
        return
      }
      // if ((this.formLabelAlign.type === 3 || this.formLabelAlign.type === 1) && this.formLabelAlign.des_1 === '') {
      //   this.$message({
      //     type: 'error',
      //     message: `请选择小程序`
      //   })
      //   return
      // }
      // if ((this.formLabelAlign.type === 3 || this.formLabelAlign.type === 1) && this.formLabelAlign.title === '') {
      //   this.$message({
      //     type: 'error',
      //     message: `请填写小程序标题`
      //   })
      //   return
      // }
      if ((this.formLabelAlign.type === 3 || this.formLabelAlign.type === 1) && this.formLabelAlign.app_id === '') {
        this.$message.error('请填写小程序APPID')
        return
      }
      if ((this.formLabelAlign.type === 3 || this.formLabelAlign.type === 1) && this.formLabelAlign.pagepath === '') {
        this.$message.error('请填写小程序页面路径')
        return
      }
      if ((this.formLabelAlign.type === 3 || this.formLabelAlign.type === 1) && this.formLabelAlign.source_material_id === '') {
        this.$message.error('请选择小程序封面')
        return
      }
      if (this.formLabelAlign.type !== 1) {
        delete this.formLabelAlign.enable
      }

      if (this.formLabelAlign.type === 3 || this.formLabelAlign.type === 1) {
        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.type == 1 && this.formLabelAlign.enable !== this.enable) {
          console.log('this', this.formLabelAlign.type, this.enable)
          console.log(12)
          // eslint-disable-next-line eqeqeq
          if (this.formLabelAlign.enable == 2) {
            console.log(11)

            // 开关打开的逻辑
            this.$confirm('确认关闭按钮？')
              .then(_ => {
                console.log('关闭')
                this.handleConfirm()
              })
              .catch(_ => {
                // this.formLabelAlign.enable = 1
                console.log(this.formLabelAlign.enable)
                // this.handleConfirm()
              })
          } else {
            console.log(123)

            // 开关关闭的逻辑
            this.$confirm('确认启用按钮？')
              .then(_ => {
                console.log('启用')
                this.handleConfirm()
              })
              .catch(_ => {
                // this.formLabelAlign.enable = 2
                console.log(this.formLabelAlign.enable)
                // this.handleConfirm()
              })
          }
        } else {
          this.handleConfirm()
        }
      } else {
        const data = await updateByMpId({
          type: this.formLabelAlign.type,
          remark: this.formLabelAlign.remark,
          id: this.formLabelAlign.id,
          preview: false
        })
        this.$emit('updata')
        console.log(data)
      }
    },
    async handleConfirm() {
      // eslint-disable-next-line eqeqeq
      if (this.alltype == 2) {
        console.log('this.formLabelAlign', this.formLabelAlign)
        try {
          const allobg = {}
          allobg.app_id = this.formLabelAlign.app_id
          allobg.id = this.formLabelAlign.id
          allobg.pagepath = this.formLabelAlign.pagepath
          allobg.remark = this.formLabelAlign.remark
          allobg.source_material_id = this.formLabelAlign.source_material_id
          allobg.title = this.formLabelAlign.title
          allobg.type = this.formLabelAlign.type
          allobg.check = this.formLabelAlign.check
          if (this.formLabelAlign.type === 3) {
            const data = await updateByMpId({ ...this.formLabelAlign, preview: false, official_app_id: this.app_idr })
            // eslint-disable-next-line eqeqeq
            if (data.code == 201) {
              this.link = data.data.mps
              this.$confirm(`需要补全链接, 是否继续?`, '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                closeOnClickModal: false,
                type: 'warning'
              })
                .then(() => {
                  this.formLabelAlign.pagepath = this.link[0].pagepath
                })
                .catch(() => {})
              this.$message.success('编辑成功')
            } else {
              this.$emit('updata')
              console.log(data)
            }
          } else {
            const data = await updateByMpId({ ...allobg, preview: false, official_app_id: this.app_idr })
            // eslint-disable-next-line eqeqeq
            if (data.code == 201) {
              this.link = data.data.mps
              this.$confirm(`需要补全链接, 是否继续?`, '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                closeOnClickModal: false,
                type: 'warning'
              })
                .then(() => {
                  this.formLabelAlign.pagepath = this.link[0].pagepath
                })
                .catch(() => {})
              this.$message.success('编辑成功')
            } else {
              this.$emit('updata')
              console.log(data)
            }
          }
        } catch (err) {
          if (err.message === '小程序获取ghid失败，请填写后再提交') {
            console.log('data.code 202')
            // this.$message.error('请添加gh_id')
            this.ghId = true
          }
        }
      } else {
        console.log('复用')
        try {
          const data = await createMiniprogram({
            type: this.formLabelAlign.type,
            remark: this.formLabelAlign.remark,
            preview: false,
            official_app_id: this.app_idr,
            mps:
              this.formLabelAlign.type === 3
                ? [{ title: this.formLabelAlign.title, check: this.formLabelAlign.check, app_id: this.formLabelAlign.app_id, pagepath: this.formLabelAlign.pagepath, source_material_id: this.formLabelAlign.source_material_id, recent_reading_page: this.formLabelAlign.recent_reading_page /* gh_id: this.formLabelAlign.gh_id */ }]
                : [{ title: this.formLabelAlign.title, check: this.formLabelAlign.check, app_id: this.formLabelAlign.app_id, pagepath: this.formLabelAlign.pagepath, source_material_id: this.formLabelAlign.source_material_id /* gh_id: this.formLabelAlign.gh_id */ }]
          })
          // eslint-disable-next-line eqeqeq
          if (data.code == 201) {
            this.link = data.data.mps
            this.$confirm(`需要补全链接 是否继续?`, '提示', {
              confirmButtonText: '是',
              cancelButtonText: '否',
              closeOnClickModal: false,
              type: 'warning'
            })
              .then(() => {
                this.formLabelAlign.pagepath = this.link[0].pagepath
                // createMiniprogram({
                //   ...this.formLabelAlign,
                //   check: 'false'
                // }).then((res) => {
                //   this.$emit('updatawechat')
                // })

                // this.$message({
                //   type: 'success',
                //   message: '删除成功!'
                // })
                this.$message.success('编辑成功')
              })
              .catch(() => {
                // createMiniprogram({
                //   ...this.formLabelAlign,
                //   check: 'false'
                // }).then((res) => {
                //   this.$emit('updatawechat')
                // })
                // this.$message({
                //   type: 'info',
                //   message: '已取消删除'
                // })
              })
          } else {
            this.$emit('updatawechat', this.alltype)
            this.$message.success('编辑成功')

            console.log('data', data)
          }
        } catch (err) {
          if (err.message === '小程序获取ghid失败，请填写后再提交') {
            console.log('data.code 202')
            // this.$message.error('请添加gh_id')
            this.ghId = true
          }
        }
      }
    },
    async previewrww() {
      // if (this.formLabelAlign.type === '') {
      //   this.$message({
      //     type: 'error',
      //     message: `请选择类型`
      //   })
      //   return
      // }
      if (this.formLabelAlign.type === 3 || this.formLabelAlign.type === 1) {
        if (this.app_idr === '') {
          this.$message.error('请选择预览公众号')
          return
        }
      }
      // console.log(this.formLabelAlign.corp_id, 'this.formLabelAlign.corp_id')
      // if (this.formLabelAlign.type === 3 && this.formLabelAlign.corp_id.length === 0) {
      //   console.log('进来了')
      //   this.$message({
      //     type: 'error',
      //     message: `请输入企业`
      //   })
      //   return
      // }
      // if ((this.formLabelAlign.type === 3 || this.formLabelAlign.type === 1) && this.formLabelAlign.des_1 === '') {
      //   this.$message({
      //     type: 'error',
      //     message: `请选择小程序`
      //   })
      //   return
      // }
      // if ((this.formLabelAlign.type === 3 || this.formLabelAlign.type === 1) && this.formLabelAlign.title === '') {
      //   this.$message({
      //     type: 'error',
      //     message: `请填写小程序标题`
      //   })
      //   return
      // }
      if ((this.formLabelAlign.type === 3 || this.formLabelAlign.type === 1) && this.formLabelAlign.app_id === '') {
        this.$message.error('请填写小程序APPID')
        return
      }
      if ((this.formLabelAlign.type === 3 || this.formLabelAlign.type === 1) && this.formLabelAlign.pagepath === '') {
        this.$message.error('请填写小程序页面路径')
        return
      }
      if ((this.formLabelAlign.type === 3 || this.formLabelAlign.type === 1) && this.formLabelAlign.source_material_id === '') {
        this.$message.error('请选择小程序封面')
        return
      }
      // if (this.formLabelAlign.remark === '') {
      //   this.$message({
      //     type: 'error',
      //     message: `请输入备注`
      //   })
      //   return
      // }
      // if (Array.isArray(this.formLabelAlign.corp_id)) {
      //   this.formLabelAlign.corp_id = this.formLabelAlign.corp_id.join()
      //   console.log(this.formLabelAlign.corp_id, 'this.formLabelAlign.corp_id')
      // }

      try {
        const data = await updateByMpId({ ...this.formLabelAlign, official_app_id: this.app_idr, preview: true })
        // eslint-disable-next-line eqeqeq
        if (data.code == 201) {
          this.link = data.data.mps
          this.$confirm(`需要补全链接, 是否继续?`, '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            closeOnClickModal: false,
            type: 'warning'
          })
            .then(() => {
              console.log('this.link', this.link)
              this.formLabelAlign.pagepath = this.link[0].pagepath
              // updateByMpId({
              //   ...this.formLabelAlign,
              //   check: 'false'
              // }).then((res) => {
              //   this.$emit('updata')
              // })

              // this.$message({
              //   type: 'success',
              //   message: '删除成功!'
              // })
            })
            .catch(() => {
              // updateByMpId({
              //   ...this.formLabelAlign,
              //   check: 'false'
              // }).then((res) => {
              //   this.$emit('updata')
              // })
              // this.$message({
              //   type: 'info',
              //   message: '已取消删除'
              // })
            })
        } else {
          // this.$emit('updata')
          console.log(data)
          this.$message({
            type: 'success',
            dangerouslyUseHTMLString: true,
            message: `${data.data.message.toString().replace(/,/g, '<br>')}`,
            duration: 5000
          })
        }
      } catch (err) {
        if (err.message === '小程序获取ghid失败，请填写后再提交') {
          console.log('data.code 202')
          // this.$message.error('请添加gh_id')
          this.ghId = true
        }
      }
    },
    chooseimg() {
      this.dialogVisibletwo = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    clickicon(img, key) {
      this.dialogVisibletwo = false
      this.formLabelAlign.source_material_id = key
      this.source_material_img = img
    },
    async listr() {
      const data = await repeatMiniprogramList({
        type: this.formLabelAlign.type
      })
      if (data.data == null) {
        this.options = []
        this.optionsFilter = []
      } else {
        this.options = data.data.map(item => {
          // item是数组中的每一个值
          return { label: item.des_1, value: item.app_id }
        })
        this.optionsFilter = data.data.map(item => {
          // item是数组中的每一个值
          return { label: item.des_1, value: item.app_id }
        })
        console.log('data', data)
      }
      console.log('data', data)
    },
    dataFilter(val) {
      this.value = val
      if (val) {
        this.options = this.optionsFilter.filter(item => {
          if (item.label.includes(val) || item.label.toUpperCase().includes(val.toUpperCase())) {
            return true
          }
        })
      } else {
        this.options = this.optionsFilter
      }
    },
    selectFocus(e) {
      const value = e.target.value
      setTimeout(() => {
        const input = this.$refs.searchSelect.$children[0].$refs.input
        input.value = value
      })
    },
    selectBlur() {
      console.log('失去1', this.value)
      // this.formLabelAlign.app_id = this.value
      const index = this.options.findIndex(items => {
        // eslint-disable-next-line eqeqeq
        return items.value == this.value
      })
      // eslint-disable-next-line eqeqeq
      if (index != -1) {
        console.log(index)
        console.log('找到id')
        this.formLabelAlign.app_id = this.value
        this.formLabelAlign.des_1 = this.options[index].label
      } else {
        console.log('没找到id')
        this.formLabelAlign.des_1 = this.value
        // this.formLabelAlign.app_id = ''
      }
    },
    selectChange() {
      console.log('失去2', this.value)
      this.ghId = false
      this.formLabelAlign.gh_id = ''
      const index = this.options.findIndex(items => {
        // eslint-disable-next-line eqeqeq
        return items.value == this.value
      })
      // eslint-disable-next-line eqeqeq
      if (index != -1) {
        console.log(index)
        console.log('找到id')
        this.formLabelAlign.app_id = this.value
        this.formLabelAlign.des_1 = this.options[index].label
      } else {
        console.log('没找到id')
        // this.formLabelAlign.app_id = ''
      }
    },
    visibleChange(val) {
      if (!val) {
        const input = this.$refs.searchSelect.$children[0].$refs.input
        input.blur()
      }
    },
    send(item, alltype) {
      this.alltype = alltype
      this.ghId = false
      // this.formLabelAlign.gh_id = ''
      console.log(item, 'item==')
      this.formLabelAlign.type = item.type
      this.formLabelAlign.enable = item.enable
      this.enable = item.enable
      this.listr()
      this.formLabelAlign.remark = item.remark
      this.formLabelAlign.id = item.id
      // this.formLabelAlign.corp_id = item.corp_id === '' ? '' : item.corp_id.split(',')
      this.formLabelAlign.title = item.title
      // this.formLabelAlign.des_1 = item.des_1
      this.formLabelAlign.app_id = item.app_id
      this.formLabelAlign.pagepath = item.pagepath
      this.formLabelAlign.recent_reading_page = item.recent_reading_page
      this.formLabelAlign.source_material_id = item.source_material_id
      this.formLabelAlign.check = item.pagepath.includes('.html')
      this.source_material_img = item.thumburl
      // this.value = item.des_1
      this.listre()
      this.app_idr = ''
      this.app_idrname = ''
      this.app_idrname = item.preview_account_name
      this.app_idr = item.preview_app_id
    },
    chanegertype() {
      this.ghId = false
      this.formLabelAlign.gh_id = ''
      // this.value = ''
      // this.formLabelAlign.app_id = ''
      // this.formLabelAlign.des_1 = ''
      this.listr()
    },
    radioCheck(val) {
      console.log(val)
      if (!val.check && val.pagepath.includes('.html')) {
        val.pagepath = val.pagepath.replace(/\.html/gi, '')
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.color {
  color: #b2b3b6;
}
.corp_id {
  width: 300px;
}
.formimg {
  display: flex;
  align-items: center;
}
@media (max-width: 768px){
  .color{
    display:none;
  }
  .options{
    font-size:2.5vw;
    text-overflow:wrap;
    width:auto;
    position:absolute;
    bottom:0px;
    right:20px;
  }
}
</style>
